import { render, staticRenderFns } from "./statuses.vue?vue&type=template&id=59a54c78"
import script from "./statuses.js?vue&type=script&lang=js&external"
export * from "./statuses.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports